import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IRouteInfo, RouteInfoService } from '@/Services/RouteInfo.service';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
  selector: 'app-per-breadcrumb',
  standalone: true,
  imports: [BreadcrumbModule],
  template: ` <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb> `,
})
export class AppPerBreadcrumbComponent implements OnInit {
  items: MenuItem[] = [];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/' };

  showFloatingWidget = false;
  routeInfo: IRouteInfo = {
    url: '',
    path: '',
    params: {},
    queryParams: {},
    fragment: null,
    data: {},
    timestamp: '',
  };

  private routeSubscription: Subscription;

  constructor(
    private routeInfoService: RouteInfoService,
    private router: Router
  ) {
    this.routeSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateRouteInfo();
      });
  }

  ngOnInit(): void {
    this.updateRouteInfo();
  }

  //Breadcrumb Methods
  private updateRouteInfo(): void {
    this.routeInfo = {
      url: this.routeInfoService.getCurrentUrl(),
      path: this.routeInfoService.getCurrentPath(),
      params: this.routeInfoService.getCurrentRouteParams(),
      queryParams: this.routeInfoService.getCurrentQueryParams(),
      fragment: this.routeInfoService.getCurrentFragment(),
      data: this.routeInfoService.getCurrentRouteData(),
      timestamp: new Date().toLocaleString(),
    };

    this.items = this.routeInfo.url
      .split('/')
      .slice(1)
      .map((url) => ({ label: url }));

    this.printToConsole();
  }

  printToConsole(): void {
    this.routeInfoService.printCurrentRouteInfo();
  }

  refreshInfo(): void {
    this.updateRouteInfo();
  }

  toggleFloatingWidget(): void {
    this.showFloatingWidget = !this.showFloatingWidget;
  }

  hasRouteParams(): boolean {
    return Object.keys(this.routeInfo.params).length > 0;
  }

  hasQueryParams(): boolean {
    return Object.keys(this.routeInfo.queryParams).length > 0;
  }

  hasRouteData(): boolean {
    return Object.keys(this.routeInfo.data).length > 0;
  }

  getRouteParamsList(): { key: string; value: unknown }[] {
    return Object.entries(this.routeInfo.params).map(([key, value]) => ({
      key,
      value,
    }));
  }

  getQueryParamsList(): { key: string; value: unknown }[] {
    return Object.entries(this.routeInfo.queryParams).map(([key, value]) => ({
      key,
      value,
    }));
  }

  getRouteDataString(): string {
    return JSON.stringify(this.routeInfo.data, null, 2);
  }
}
